import { render, staticRenderFns } from "./JobsTable.vue?vue&type=template&id=a72f14f8&scoped=true"
import script from "./JobsTable.vue?vue&type=script&lang=ts"
export * from "./JobsTable.vue?vue&type=script&lang=ts"
import style0 from "./JobsTable.vue?vue&type=style&index=0&id=a72f14f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a72f14f8",
  null
  
)

export default component.exports